import React, { useEffect } from "react";
import Canvas from "../../components/Canvas";

const Login = ({ title }) => {
  useEffect(() => {
    const original = document.title;
    document.title = title + " | " + original;
    return () => {
      document.title = original;
    };
  }, [title]);

  return (
    <section className="hero-section auth-page">
      <Canvas />
      <form className="card auth-card">
        <p className="eyebrow">Portal access</p>
        <h1>Login</h1>
        <p>Sign in to continue to your Lovapex portal.</p>
        <label className="field">
          <span className="field-label">
            Email
            <span className="required-marker" aria-hidden="true">
              *
            </span>
          </span>
          <input placeholder="Enter your email address" type="email" />
        </label>
        <label className="field">
          <span className="field-label">
            Password
            <span className="required-marker" aria-hidden="true">
              *
            </span>
          </span>
          <input placeholder="Enter your password" type="password" />
        </label>
        <button
          className="button button-primary button-md full-width"
          type="submit"
        >
          Login
        </button>
      </form>
    </section>
  );
};

export default Login;
